import api from "./api";
import cache from "../utils/cache";

export const getEvents = async (payload) => {
  try {
    const response = await api.get("/events", {
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching events:", error);
    throw error;
  }
};

export const getEventImages = async (eventId, page = 1, limit = 10) => {
  try {
    const response = await api.get(
      `/event/${eventId}/images?page=${page}&limit=${limit}`
    );

    return response.data;
  } catch (error) {
    console.error("Event Images API Error:", error);
    throw error;
  }
};

export const getSummerCampVideos = async (payload) => {
  try {
    const response = await api.get("/event/summer-camp-videos", {
      params: payload,
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching summer camp videos:", error);
    throw error;
  }
};

export const getEventCertificate = async () => {
  try {
    const cacheKey = "event-certificate";
    const cachedData = await cache.get(cacheKey);
    if (cachedData) {
      /* console.log("Certificate: Cache"); */
      api.get("/event/get-certificate")
        .then(async (response) => {
          await cache.set(cacheKey, response.data, "30m");
          /* console.log("Certificate cache updated"); */
        })
        .catch((error) => {
          console.error("Background certificate API error:", error);
        });
      return cachedData;
    }
    /* console.log("Certificate: API"); */
    const response = await api.get("/event/get-certificate");
    await cache.set(cacheKey, response.data, "30m");
    return response.data;

  } catch (error) {
    console.error("Get certificate error:", error);
    throw error;
  }
};


/* export const getEventCertificate = async () => {
  try {
    const response = await api.get("/event/get-certificate");
    return response.data;
  } catch (error) {
    console.error("Get certificate error:", error);
    throw error;
  }
}; */